import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const PartnerAttributeField = ({ darkMode, errors, touched, number }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();
    
    const fieldName = () => {
        switch (number) {
            case 2:
                return FORM_FIELD_PATHS.P_ATTRIBUTE_2;
            case 3:
                return FORM_FIELD_PATHS.P_ATTRIBUTE_3;
            default:
                return FORM_FIELD_PATHS.P_ATTRIBUTE_1;
        }
    };

    const handleChange = (e) => {
        updateFormData(fieldName(), e.target.value);
    };
    
    const hasError = !!errors?.[fieldName()] && touched?.[fieldName()];
    
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Partner Attribute {number}
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id={fieldName()}
                        name={fieldName()}
                        value={formData?.[fieldName()] || ''}
                        onChange={handleChange}
                        placeholder={`Enter Partner Attribute ${number}`}
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        validate={(value) => {
                            if (value && value.length > 100) {
                                return `Partner Attribute ${number} must be less than 100 characters`;
                            }
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={`Enter custom attribute ${number} for this partner (max 100 characters)`}
                        ariaLabel={`partner-attribute${number}-tip`}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PartnerAttributeField;
